import React, { useEffect } from "react";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import {
  updateConfigurationFileBreadcrumb,
  updateShowSpecialSwitches,
} from "../../../redux/configurationFiles/configurationFilesSlice";
// COMPONENTS
import OffsetsTable from "./OffsetsTable";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const DefinitionsPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    dispatch(updateShowSpecialSwitches(false));
    dispatch(updateConfigurationFileBreadcrumb([]));
  }, []);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.Offsets, permissionSet ?? []) ? (
        <div>
          {/** HEADER AND STEPER */}
          <div className={`layout__contentPage__${theme}`}>
            <OffsetsTable />
          </div>
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default DefinitionsPage;
